import { render, staticRenderFns } from "./InternalSubmenu.vue?vue&type=template&id=4da43c2c"
import script from "./InternalSubmenu.vue?vue&type=script&lang=js"
export * from "./InternalSubmenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports